import React from "react"
import MegaMenu from "../MegaMenu"

const MegaMenuProductCategoriesTree = ({
  name = "",
  card = [],
  megaMenuData = [],
  isMegaMenuActive,
  triggerParentUpdate,
}) => {
  const processData = (items) => {
    return items.map(({ children, attributes, products }) => {
      const itemVisibility = attributes?.isVisibleInMegaMenu
      const itemLabel = attributes?.label
      const itemRoute = attributes?.autoRoute
      return {
        label: itemLabel,
        route: itemRoute,
        visibility: itemVisibility,
        children: children ? processData(children) : [],
        products: products ? processData(products) : [],
      }
    })
  }
  const currentProducts = megaMenuData?.products || []
  const megaMenuDataChildren = megaMenuData?.children || []
  const data = processData([...currentProducts, ...megaMenuDataChildren])
  return (
    <MegaMenu
      data={data}
      name={name}
      card={card && card}
      isMegaMenuActive={isMegaMenuActive}
      triggerParentUpdate={triggerParentUpdate}
    />
  )
}

export default MegaMenuProductCategoriesTree
